// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"GoodToKnowSection_contentContainer__IjIRw","infoBlock":"GoodToKnowSection_infoBlock__wygMr","infoBlockContainer":"GoodToKnowSection_infoBlockContainer__aPKkO"};